module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/placeholder-7c5cd27a2b750fac4392174c4439e3b7.png";